exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "iframe {\n    border: none;\n    display: block;\n    width: 100%;\n    height: 100vh;\n    margin: 0 auto;\n    box-sizing: border-box;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/open-banking/open-banking.component.css
// module id = ../../../../../src/app/open-banking/open-banking.component.css
// module chunks = main